import React, { useState, Fragment, createContext, useContext, useEffect, useRef } from "react";
import AppModal from "./AppModal";
import getErrorMessage from "../utilities/getErrorMessage";
import AppModalAlertMessage from "./AppModalAlertMessage";
import InputTextarea from "./InputTextarea";
import axiosInstance from "../utilities/axiosInstance";

const IconPill = require("../../assets/images/gaadaobat.svg");
const IconMedicine = require("../../assets/images/obat.svg");
const IconNote = require("../../assets/images/note-pasien.svg");

const DoctorNoteContext = createContext({ isEditNote: false, setIsEditNote: null });
const DoctorNoteProvider = (props) => {
	const [isEditNote, setIsEditNote] = useState(false);
	return (
		<DoctorNoteContext.Provider value={{ isEditNote, setIsEditNote }}>{props.children}</DoctorNoteContext.Provider>
	);
};

const BottomSheetModal = (props) => {
	return (
		<AppModal isOpen={props.isOpen} onRequestClose={props.onRequestClose} shouldCloseOnOverlayClick isActionSheet>
			<ul className="listview image-listview flush transparent mt-3 mb-2">
				{props.isEdit && (
					<li>
						<a className="item cursor-pointer" onClick={props.onEditClick}>
							<div className="icon-box ">
								<ion-icon name="create" role="img" className="md hydrated" aria-label="create" />
							</div>
							<div className="in">Edit</div>
						</a>
					</li>
				)}
				<li>
					<a className="item cursor-pointer" onClick={props.onDeleteAllClick}>
						<div className="icon-box ">
							<ion-icon name="trash" role="img" className="md hydrated" aria-label="trash" />
						</div>
						<div className="in">Delete All</div>
					</a>
				</li>
			</ul>
		</AppModal>
	);
};

const FloatingActionButton = (props) => {
	const { setIsEditNote } = useContext(DoctorNoteContext);

	return (
		<div className="box-max-width">
			<div className="wrap-box">
				<div className="fab-button animate bottom-right dropdown">
					<a href="#" className="fab" data-toggle="dropdown">
						<ion-icon name="add-outline" role="img" className="md hydrated" aria-label="add outline" />
					</a>
					<div className="dropdown-menu">
						<a
							className="dropdown-item"
							href={`/doctor/consultations/${props.consultation_id}/recipe/medicines/new`}
						>
							<ion-icon
								name="medkit-outline"
								role="img"
								className="md hydrated"
								aria-label="medkit outline"
							/>
							<p>Add Medicine</p>
						</a>
						<a className="dropdown-item" onClick={() => setIsEditNote(true)}>
							<ion-icon
								name="document-text-outline"
								role="img"
								className="md hydrated"
								aria-label="document text outline"
							/>
							<p>Add Notes</p>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

const MedicineListItem = (props) => {
	const id = `medichine-item-${Math.floor(Math.random() * 100)}`;

	return (
		<div className="item">
			<div className="accordion-header">
				<button
					className="btn collapsed"
					type="button"
					data-toggle="collapse"
					data-target={`#${id}`}
					aria-expanded="false"
				>
					<img src={IconPill} width={25} className="mr-2" alt="" />
					{props.name}
				</button>
			</div>
			<div id={id} className="accordion-body collapse" data-parent="#medichine-accordion">
				<div className="accordion-content">
					<div className="mb-2">
						<p className="font12 mb4 d-flex justify-content-between">
							Quantity
							<span>
								{props.quantity} {props.quantity_unit}
							</span>
						</p>
						<p className="font12 mb4 d-flex justify-content-between">
							Dosage
							<span>
								{props.dosage} {props.dosage_unit}
							</span>
						</p>
						<p className="font12 mb4 d-flex justify-content-between">
							Frequency (times a day)
							<span>{props.frequency}</span>
						</p>
						<p className="font12 mb4 d-flex justify-content-between">
							When to use
							<span>{props.when_to_use[0] && props.when_to_use.join(", ")}</span>
						</p>
					</div>
					{props.note && (
						<div className="box-notes">
							<h5>Notes</h5>
							<span className="font12">{props.note}</span>
						</div>
					)}
					<div className="d-flex mt-3">
						<a
							href={`/doctor/consultations/${props.consultation_id}/recipe/medicines/${props.id}/edit`}
							className="w-100 btn btn-text-secondary float-right"
						>
							<ion-icon
								name="create-outline"
								role="img"
								className="md hydrated"
								aria-label="create outline"
							/>
							Edit
						</a>
						<a
							className="w-100 btn btn-text-primary float-right"
							data-confirm="Are you sure want to delete data?"
							data-verify=""
							href={`/doctor/consultations/${props.consultation_id}/recipe/medicines/${props.id}`}
							data-verify-text="Type your username to confirm"
							rel="nofollow"
							data-method="delete"
						>
							<ion-icon
								name="trash-outline"
								role="img"
								className="md hydrated"
								aria-label="trash outline"
							/>
							Delete
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

const MedicineList = (props) => {
	const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
	const [alertMessage, setAlertMessage] = useState({ success: null, error: null });

	const onDeleteAllClick = async () => {
		try {
			const request = {
				consultation_id: props.consultation_id,
				medicine_ids: props.medicines.map((m) => m.id),
			};
			const { data } = await axiosInstance.post("/api/doctor/medicines/batch_delete", request);

			if (data.success) {
				setAlertMessage({ error: null, success: data.message });
				setTimeout(() => Turbolinks.visit(), 1000);
			}
		} catch (err) {
			const error = getErrorMessage(err);
			setAlertMessage({ success: null, error });
		} finally {
			setIsBottomSheetOpen(false);
		}
	};

	return (
		<Fragment>
			<div className="card mb-3">
				<div className="card-body">
					<div className="obat-ss mb-2">
						<img src={IconMedicine} width={35} alt="" />
						<h5 className="ml-1 mt-1">Medicine Recommedation</h5>
						<a className="titik-option" onClick={() => setIsBottomSheetOpen(true)}>
							<ion-icon
								name="ellipsis-vertical"
								role="img"
								className="md hydrated"
								aria-label="ellipsis vertical"
							/>
						</a>
					</div>
					<div className="accordion mb-3" id="medichine-accordion">
						{props.medicines &&
							props.medicines.map((m) => (
								<MedicineListItem consultation_id={props.consultation_id} key={m.id} {...m} />
							))}
					</div>
				</div>
			</div>
			<BottomSheetModal
				isOpen={isBottomSheetOpen}
				onRequestClose={() => setIsBottomSheetOpen(false)}
				onDeleteAllClick={onDeleteAllClick}
			/>
			<AppModalAlertMessage message={alertMessage} setMessage={setAlertMessage} />
		</Fragment>
	);
};

const DoctorNote = ({ recipe, consultation_id }) => {
	const { isEditNote, setIsEditNote } = useContext(DoctorNoteContext);
	const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
	const [alertMessage, setAlertMessage] = useState({ success: null, error: null });
	const [loading, setLoading] = useState(false);
	const [note, setNote] = useState(recipe?.note || "");
	const textArea = useRef();

	const saveDoctorNote = async (isDelete = false) => {
		setLoading(true);
		try {
			const request = { note: isDelete ? "" : note };
			const url = `/api/doctor/consultations/${consultation_id}/recipe`;
			const { data } = await axiosInstance.put(url, request);

			if (data?.success) {
				setAlertMessage({ error: null, success: data.message });
				setIsEditNote(false);
				setTimeout(() => Turbolinks.visit(), 1000);
			}
		} catch (err) {
			const error = getErrorMessage(err);
			setAlertMessage({ success: null, error });
		} finally {
			setLoading(false);
		}
	};

	const onBottomSheetEditClick = () => {
		setIsEditNote(true);
		setIsBottomSheetOpen(false);
	};

	const onBottomSheetDeleteAllClick = () => {
		setNote("");
		setIsBottomSheetOpen(false);
		saveDoctorNote(true);
	};

	const onEditCancel = () => {
		setIsEditNote(false);
		if (recipe.note !== note) {
			setNote(recipe?.note || "");
		}
	};

	useEffect(() => {
		if (isEditNote) {
			setTimeout(() => textArea.current.focus(), 100);
		}
	}, [isEditNote]);

	return (
		<Fragment>
			<div className="card mb-3">
				<div className="card-body">
					<div className="obat-ss mb-2">
						<img src={IconNote} width={35} alt="" />
						<h5 className="ml-1 mt-1">Doctor notes</h5>
						<a className="titik-option" onClick={() => setIsBottomSheetOpen(true)}>
							<ion-icon
								name="ellipsis-vertical"
								role="img"
								className="md hydrated"
								aria-label="ellipsis vertical"
							/>
						</a>
					</div>
					{isEditNote ? (
						<Fragment>
							<InputTextarea ref={textArea} value={note} setValue={setNote} disabled={loading} />
							<div className="row mx-0 mb-2">
								<div className="col-6 pl-0">
									<button
										className="btn btn-second-app btn-block"
										onClick={onEditCancel}
										disabled={loading}
									>
										Cancel
									</button>
								</div>
								<div className="col-6 pr-0" onClick={() => saveDoctorNote()}>
									<button className="btn btn-outline-success btn-block" disabled={loading}>
										{loading ? "Please wait..." : "Save notes"}
									</button>
								</div>
							</div>
						</Fragment>
					) : note === "" ? (
						<div className="row mx-0 mt-2 mb-2">
							<div className="col-6 mx-auto">
								<button
									className="btn btn-outline-success btn-block"
									onClick={() => setIsEditNote(true)}
								>
									Add notes
								</button>
							</div>
						</div>
					) : (
						<div className="mt-2 mb-2">
							<p>{note}</p>
						</div>
					)}
				</div>
			</div>
			<BottomSheetModal
				isEdit
				isOpen={isBottomSheetOpen}
				onRequestClose={() => setIsBottomSheetOpen(false)}
				onEditClick={onBottomSheetEditClick}
				onDeleteAllClick={onBottomSheetDeleteAllClick}
			/>
			<AppModalAlertMessage message={alertMessage} setMessage={setAlertMessage} />
		</Fragment>
	);
};

const SendToPharmacyButton = ({ recipe, consultation_id }) => {
	const [alertMessage, setAlertMessage] = useState({ success: null, error: null });
	const [loading, setLoading] = useState(false);

	const onClick = async () => {
		setLoading(true);
		try {
			const { data } = await axiosInstance.post(`/api/doctor/consultations/${consultation_id}/recipe/processing`);
			if (data?.success) {
				setAlertMessage({ error: null, success: data.message });
				setTimeout(() => Turbolinks.visit(), 1000);
			}
		} catch (err) {
			const error = getErrorMessage(err);
			setAlertMessage({ success: null, error });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Fragment>
			{recipe.status === "pending" && (
				<div className="mt-3 mb-3">
					<button onClick={onClick} className="btn btn-primary btn-block" disabled={loading}>
						{loading ? "Processing..." : "Sent to pharmacist"}
					</button>
				</div>
			)}
			<AppModalAlertMessage message={alertMessage} setMessage={setAlertMessage} />
		</Fragment>
	);
};

const ConsultationDetail = (props) => {
	return (
		<Fragment>
			<MedicineList consultation_id={props.consultation_id} medicines={props.medicines} />
			<DoctorNoteProvider>
				<DoctorNote recipe={props.recipe} consultation_id={props.consultation_id} />
				<FloatingActionButton consultation_id={props.consultation_id} />
			</DoctorNoteProvider>
			<SendToPharmacyButton recipe={props.recipe} consultation_id={props.consultation_id} />
		</Fragment>
	);
};

export default ConsultationDetail;
